import './bootstrap';

import { createApp, h, onErrorCaptured, onBeforeMount } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy'; // à voir si ça fonctionne bien.. sinon, l'autre ↓
// import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist';

import VueDOMPurifyHTML from 'vue-dompurify-html'; // use directive : v-dompurify-html  instead v-html  (https://www.npmjs.com/package/vue-dompurify-html)

import config from './config'

import { store, appStore } from '@stores' //* Pinia
// log(store)

import asyncComponents from './asyncComponents'

import VueGuidedTour from "vue-guided-tour";

import quasar from './quasar.conf'

import directives from './directives'

import AppLayout from '@/Layouts/App.vue'
import AuthLayout from '@/Layouts/Auth.vue'

import {
    // pp,
    // notify
    app_state,
    toggleSquare,
    flash,
    counterInactivity,
    scrollTo,
    setTabsOpened,
    e,
} from '@helpers'

// const appName = import.meta.env.VITE_APP_NAME || '';

// ----------------------------------
/**
 * Lorsqu'un nouveau déploiement se produit, le service d'hébergement peut supprimer les actifs des déploiements précédents.
 * Par conséquent, un utilisateur ayant visité votre site avant le nouveau déploiement peut rencontrer une erreur d'importation.
 * Cette erreur se produit car les actifs exécutés sur l'appareil de cet utilisateur sont obsolètes et il tente d'importer l'ancien morceau correspondant, qui est supprimé.
 * Cet événement est utile pour remédier à cette situation.
 *
 * https://vite.dev/guide/build.html#load-error-handling
 */
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault() // ne pas générer l'erreur
    window.location.reload() // for example, refresh the page
})

// define decrement counter part
// relation avec : helpers/others.js @setTabsOpened()
window.addEventListener('pagehide', function (e) {

    const newTabCount = localStorage.getItem(app_state().tabsOpenKey) // this.getTabsOpened(<- don't work..!?!) // this.getTabsOpenedNumber(<- don't work..!?!)

    if (newTabCount !== null) {
        localStorage.setItem(app_state().tabsOpenKey, newTabCount - 1)
    }
});




createInertiaApp({
    title: (title) => `${title} - ${app_state().app_name}`,
    // resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    resolve: name => {
        // const pages =
        //     import.meta.glob('./Pages/**/*.vue', {
        //         eager: true
        //     })
        // const page = pages[`./Pages/${name}.vue`]

        const page = resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'))
        page.then((module) => {

            var Layout = _.includes(name, 'Auth') || _.includes(['Welcome','PageNotFound','TermsOfService','PrivacyPolicy'], name)
                                ? AuthLayout : AppLayout

            module.default.layout = Layout
// log('MODULE', module)
        });
        return page;

    },
    setup({ el, App, props, plugin }) {

        const VueApp =
            createApp({
                render: () => h(App, props),

                // beforeMount(){
                //     // log('in app.js',props)
                //     appStore().getAllUsers(true/* , props.initialPage?.props?.user */)
                // },

                mounted(){
                    // appStore().setDatas()
                    appStore().customizer()


                    if($q.cookies.get('square_mode')){
                        if ($q.cookies.get('square_mode') === 'true') {
                            app_state().squared = false
                        } else { app_state().squared = true }
                    } else {
                        app_state().squared = true
                    }
                    toggleSquare()

                },
                // methods: {
                // },

                setup(){

					onBeforeMount(()=>{

						setTabsOpened()

						// app_state.openDrawerLeft  = proto.$_hasTouch ? false : app_state.openDrawerLeft  // auto hide drawer left  (if hasTouch support)
					})

                    onErrorCaptured((error_obj/* , instance, infos */)=> { // https://vuejs.org/api/composition-api-lifecycle.html#onerrorcaptured

                        // log('in onErrorCaptured', error_obj, /* instance, instance.$el?.baseURI, instance.route().current(), infos, this.$page, */ props)
                                var component =  props?.initialPage?.component /* || this.$page?.component */ || '???'//_.escape(component._name),
                                //     // tag = component.$vnode ? component.$vnode.tag : '',
                                  var  uri = /* instance?.$el?.baseURI || */ props?.initialPage?.url || '???'//this.$page?.url || '???';//component.$el ? component.$el.baseURI : '';

                                // error('errorCaptured in :', component,' - URI:', uri, ' - Error:',error_obj/* , instance, infos */)

                                // e(`Captured: ~~~COMPONENT: ${component} ~~~URI: ${uri} ~~~ERROR: ${error_obj}`);// 'error_obj' always in last (for notify.js@error()) <br/>INFOS: ${infos}
                                e('ERROR-CAPTURED()', {component: component, uri: uri, error_obj: error_obj});
                            })

                            // appCreate.config.globalProperties.$inertia.on('before', (event) => {
                            proto.$inertia.on('before', (event) => {
                                var searchParams = event.detail.visit.url.searchParams

                                // log(  searchParams.has('filter') ,  searchParams.toString(), props?.initialPage?.url, event.detail.visit.url.pathname, event.detail.visit.method )

                                // if(cgp.$page.url/*previous page*/ != event.detail.visit.url.pathname/* future page*/
                                if(props?.initialPage?.url/*previous page*/ != event.detail.visit.url.pathname/* future page*/
                                    && event.detail.visit.method == 'get'
                                    // && ! (searchParams.has('email') || searchParams.has('filter') || searchParams.has('notransition'))
                                    && ! searchParams.toString()?.length
                                ){

                                    // app_state.value.show_page = false // for transition in AppLayout
                                    app_state().show_page = false // for transition in AppLayout
                                }

                            });
                            // appCreate.config.globalProperties.$inertia.on('success', (event) => {
                            proto.$inertia.on('success', (event) => {
                                // log(`SUCCESS The route changed to` , route().current(), 'PARAMS:',route().params,'EVENT:', event)
                                // log(`SUCCESS The route changed to` ,proto.$page.url, '>', event.detail.visit)

                                // app_state.current_route = route().current()

                                if(route().params?.hash){
                                    _.delay(()=>{
                                        scrollTo(route().params.hash)
                                    },500)
                                }

                                // app_state.show_page = true // for transition in AppLayout
                            });
                },

                watch:{
                    // async
                    '$page'(v_new/* , v_old */){

                        appStore().getAllUsers()

                        // log('in app.js WATCH $page', v_new, route().current())

                        app_state().current_page_for_guided_tour = route().current()

                        app_state().openDrawerLeft  = proto.$_hasTouch ? false : app_state().openDrawerLeft  // auto hide drawer left  (if hasTouch support)
                        app_state().openDrawerRight = proto.$_hasTouch ? false : app_state().openDrawerRight // auto hide drawer right (if hasTouch support)

                        app_state().show_page = true // for transition in AppLayout

                        counterInactivity(v_new.props?.user)// helpers/others

                        flash(v_new.props)
                    }
                }
            })
            .use(VueDOMPurifyHTML)
            .use(store)
            .use(quasar)
            .use(config)
            .use(asyncComponents)
            .use(directives)
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(VueGuidedTour)// Vue GUIDED TOUR - help users

        // window.proto = _.omit(VueApp.config.globalProperties, ['$page', '$q', '$store']) NON, enlève $inertia aussi..?!?!?
        window.proto = VueApp.config.globalProperties

        VueApp.mount(el /* , true */ )

    },
})








// createInertiaApp({
//     title: (title) => `${title} - ${appName}`,
//     resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
//     setup({ el, App, props, plugin }) {
//         return createApp({ render: () => h(App, props) })
//             .use(plugin)
//             .use(ZiggyVue)
//             .mount(el);
//     },
//     progress: {
//         color: '#4B5563',
//     },
// });
